import notify from "@irati/utils/notify"

const helper = {}

helper.notifyError = (error, formatMessage) => {
  notify.error({message: formatMessage({id: `error.${error.errorCode}`}), position: "top-right"})
}

export const notifyError = helper.notifyError

export default helper
